import { AuditLogField } from "src/app/modules/core/decorators/decorators";
import { DateTime } from 'luxon';

export class GuardTour {
  [key: string]: string | number | boolean | any;
  id: number;
  name: string;
  description: string;
  guardTourTypeId: number;
  isActive: boolean;
  customerIds: number[];
  createdBy: number;
  createdDate: DateTime;
  updatedBy: number;
  updatedDate: DateTime;

  get customerId(): number {
    if (this.customerIds !== undefined && this.customerIds !== null && this.customerIds.length > 0)
      return this.customerIds[0];

    return 0;
  }
}

export class CreateEditGuardTour {
  id!: number | undefined;
  @AuditLogField
  name!: string | undefined;
  @AuditLogField
  description!: string | undefined;
  @AuditLogField
  guardTourTypeId!: number | undefined;
  timeZoneId!: number | undefined;
  @AuditLogField
  cycleMins!: number | undefined;
  @AuditLogField
  isActive!: boolean | undefined;
  daysIntervals!: any | undefined;
  deviceIds!: number[] | undefined;
  siteIds!: number[] | undefined;
  customerIds!: number[] | undefined;
  selectedDevices!: SelectedDeviceDto[] | undefined;
}

export class SelectedDeviceDto {
  id!: number | undefined;
  name!: string | undefined;
  parentId!: number | undefined;
  parentName!: string | undefined;
  siteId!: number;
}

export const EventColors: any = {
  existingEvent: {
      primary: '#1E90FF',
      secondary: '#D1E8FF'
  },
  newEvent: {
      primary: '#E3BC08',
      secondary: '#FDF1BA'
  }
}

export class DisplaySelectedSite {
  siteId: number;
  siteName: string;
  nvrs: Array<DisplaySelectedNVR>;
}

export class DisplaySelectedNVR {
  nvrId: number;
  nvrName: string;
  cameras: Array<DisplaySelectedCamera>;
}

export class DisplaySelectedCamera {
  cameraId: number;
  cameraName: string;
}